import Typography from './Typography';
import * as TypographyMappings from './configurations';
// This check is added to make the files load as a side effect.
if (TypographyMappings === undefined) {
    console.error('TypographyMappings is undefined');
}
export * from './configurations';
export * from './legacyStyles';
export * from './utils';
export * from './Typography';
export { TypographyMappings };
export * from './types';
export * from './enum';
export default Typography;
